import {
  GlobalConstantsSonstige
} from 'globales-projekt-angular';
import { Guid } from 'guid-typescript';
import { FilterAuspRow } from 'src/app/data/klassen/filter-ausp-row.model';
import { ModulPrAuspFilter } from 'src/app/data/ws/modul/modul-pr-ausp-filter.model';
import { FilterAuspTabelleComponent } from '../filter-ausp-tabelle/filter-ausp-tabelle.component';
import { GlobalService } from 'globales-projekt-angular';
import { ApplicationRef, Component, ComponentFactory, ComponentFactoryResolver, ComponentRef, EmbeddedViewRef, Injector, OnInit } from '@angular/core';
import { AuswahlComponent } from 'src/app/components/pages/anwendung/auswahl/auswahl.component';

@Component({
  selector: 'app-filter-ausp-row',
  templateUrl: './filter-ausp-row.component.html',
  styleUrls: ['./filter-ausp-row.component.css']
})
export class FilterAuspRowComponent implements OnInit {
  filterAuspRow!: FilterAuspRow;

  public parentMainComponent!: AuswahlComponent;
  
  id!: Guid;

  childGuidFilterAuspTabelle: Guid[] = [];
  childRefFilterAuspTabelle: ComponentRef<FilterAuspTabelleComponent>[] = [];

  constructor( 
    private cfr: ComponentFactoryResolver,
    public globalService: GlobalService,
    private injector: Injector,
    private appRef: ApplicationRef) { }

  ngOnInit(): void {
  }

  setVariablen(filterAuspRow: FilterAuspRow) { 
    this.filterAuspRow = filterAuspRow;
  }

  createSubTables()
  {
  

    if (this.filterAuspRow.modulPrAuspFilterLinks)
      this.createSubTable(this.filterAuspRow.modulPrAuspFilterLinks, GlobalConstantsSonstige.DOM_CONTENT_DATEN_7);
    if (this.filterAuspRow.modulPrAuspFilterRechts)
      this.createSubTable(this.filterAuspRow.modulPrAuspFilterRechts, GlobalConstantsSonstige.DOM_CONTENT_DATEN_8);
  }

  createSubTable(modulPrAuspFilter: ModulPrAuspFilter, domElement: string) {
    // Erstelle die Komponente
    let filterDatentabelle: ComponentFactory<FilterAuspTabelleComponent> =
      this.cfr.resolveComponentFactory(FilterAuspTabelleComponent);
    let componentRef: ComponentRef<FilterAuspTabelleComponent> =
    filterDatentabelle.create(this.injector);

    // Setze Werte und füge die Komponente zur DOM hinzu
    let id: Guid = Guid.create();
    this.childGuidFilterAuspTabelle.unshift(id);

    componentRef.instance.id = id;
    componentRef.instance.parentMainComponent = this;
    componentRef.instance.setVariablen(modulPrAuspFilter);

    this.childRefFilterAuspTabelle.unshift(componentRef);

    this.appRef.attachView(componentRef.hostView);
    let domElem: Node = (componentRef.hostView as EmbeddedViewRef<any>)
      .rootNodes[0] as HTMLElement;

   
    // Finde das Ziel-DOM-Element und ersetze es durch die neue Komponente
    let targetElement = document.getElementById(domElement);
    if (targetElement) {
      targetElement.removeAttribute('id'); // TODO in Globales Projekt verschieben
      targetElement.appendChild(domElem);
    }
  }
}
